"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const analytics_1 = require("@completeanatomy/analytics");
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
function ScreenName({ name, creator }) {
    const { t } = (0, i18n_1.useTranslation)();
    const [tooltipIsOpen, setTooltipIsOpen] = (0, react_1.useState)(false);
    const analytics = (0, analytics_1.useAnalytics)();
    const sendAnalyticsEvent = (title) => {
        const segmentation = {
            name: title,
            accessLocation: analytics_1.AnalyticsAccessLocation.MainMenu,
        };
        analytics.log('screen_name_truncated', segmentation);
    };
    const onClick = () => {
        sendAnalyticsEvent(name);
        setTooltipIsOpen(!tooltipIsOpen);
    };
    const onHover = () => {
        sendAnalyticsEvent(name);
        setTooltipIsOpen(true);
    };
    const onLeave = () => {
        setTooltipIsOpen(false);
    };
    const onFocus = () => {
        setTooltipIsOpen(true);
    };
    const onBlur = () => {
        setTooltipIsOpen(false);
    };
    const created = t(i18n_1.Strings.toolbar.createdBy) + ':' + creator.name;
    const tooltipContext = ((0, jsx_runtime_1.jsxs)(Container, { children: [(0, jsx_runtime_1.jsx)(StyledAvatar, { image: creator.image, grasshopper: true }), (0, jsx_runtime_1.jsxs)(TextBlock, { children: [name, (0, jsx_runtime_1.jsx)("br", {}), created] })] }));
    return ((0, jsx_runtime_1.jsx)(StyledTruncatedText, { onClick: onClick, onMouseEnter: onHover, onMouseLeave: onLeave, onFocus: onFocus, onBlur: onBlur, tabIndex: 0, center: false, tooltip: {
            context: tooltipContext,
            isOpen: tooltipIsOpen,
            isTouchDeviceAvailable: true,
            styles: {
                padding: '8px',
                margin: '0 16px',
                backgroundColor: (0, ui_1.getTheme)().grasshopper.tooltipBackground.light,
                color: (0, ui_1.getTheme)().grasshopper.text.tooltipDark,
            },
        }, children: name }));
}
const Container = styled_components_1.default.div `
  display: flex;
  align-items: center;
  max-width: calc(100vw - 52px);
`;
const StyledAvatar = (0, styled_components_1.default)(ui_1.Avatar) `
  width: 32px;
  height: 32px;
  background-color: ${({ theme }) => theme.grasshopper.avatar};
  display: inline-block;
  margin-right: 8px;
  flex-shrink: 0;
`;
const TextBlock = styled_components_1.default.div `
  display: inline-block;
  font-size: 16px;
  line-height: 18.32px;
  font-weight: 400;
`;
const StyledTruncatedText = (0, ui_1.withTooltip)((0, styled_components_1.default)(ui_1.TruncatedText) `
  padding: 0 4px;
  color: ${({ theme }) => theme.grasshopper.text.white};
  font-size: 16px;
  line-height: 40px;
  font-weight: 400;
  height: 40px;
  box-sizing: border-box;

  &:focus {
    outline: none;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.designSystem.accent};
    outline-offset: 2px;
    border-radius: 1px;
  }
`);
exports.default = ScreenName;
